import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { ChangeEvent } from "utils/history/Event";
import { isEmpty } from "utils/Utils";

import { TextField } from "../FieldService";
import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type TextInputProps = {
	field: TextField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const TextInput: React.FC<TextInputProps> = (props: TextInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required ? !isEmpty(value) : true;
	}

	function onChange(newValue: string): void {
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, isValid(newValue));
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={6}>
				{props.editable &&
				props.rights[props.field.uuid][InformationRight.WRITE] ? (
					<ManagedTextField
						id={props.field.name}
						fullWidth
						required={props.field.required}
						error={!isValid(props.field.value)}
						value={props.field.value}
						onUpdate={onChange}
						variant="standard"
					/>
				) : (
					<Typography variant="body2" sx={{ wordWrap: "break-word" }}>
						{props.field.value}
					</Typography>
				)}
			</Grid>
		</Grid>
	);
};

export default TextInput;
